// Ana sayfa banner'ları `/sliders` yanıtıyla gelir; yanıt gecikirse vitrinin
// yerinde saniyelerce yükleme yer tutucusu durur. Son görülen banner listesi bu
// yüzden localStorage'a yazılır ve ilk boyamada hemen çizilir — tema, favicon ve
// marka önbellekleriyle aynı yöntem. Taze liste geldiğinde üzerine yazılır,
// yani panelden kaldırılan bir banner en fazla bir açılış boyunca görünür.
export const SLIDER_CACHE_KEY = 'app:home-sliders-v1';

// Vitrin zaten bu kadarını çiziyor; daha uzun liste önbelleği şişirir.
const MAX_SLIDES = 12;

const storageOf = (storage) => (
  storage !== undefined
    ? storage
    : (typeof window !== 'undefined' ? window.localStorage : null)
);

// Yalnızca çizim için gereken alanlar saklanır.
const pick = (slide) => ({
  id: slide.id,
  image: slide.image || '',
  title: slide.title || '',
  subtitle: slide.subtitle || '',
  highlight: slide.highlight || '',
  description: slide.description || '',
  cta_text: slide.cta_text || '',
  cta_link: slide.cta_link || '',
  placement: slide.placement || 'main',
});

export const readCachedSliders = (storage) => {
  try {
    const raw = storageOf(storage)?.getItem(SLIDER_CACHE_KEY);
    const items = raw ? JSON.parse(raw) : null;
    if (!Array.isArray(items)) return [];
    return items
      .filter((slide) => slide && typeof slide === 'object' && slide.id !== undefined)
      .slice(0, MAX_SLIDES)
      .map(pick);
  } catch {
    // Gizli/katı tarayıcı oturumlarında localStorage okunamayabilir.
    return [];
  }
};

export const cacheSliders = (items, storage) => {
  const list = Array.isArray(items) ? items.filter(Boolean).slice(0, MAX_SLIDES).map(pick) : [];
  try {
    const target = storageOf(storage);
    if (list.length === 0) target?.removeItem(SLIDER_CACHE_KEY);
    else target?.setItem(SLIDER_CACHE_KEY, JSON.stringify(list));
  } catch {
    // Depolama kapalıysa vitrin yine normal çalışır, yalnızca yer tutucu görünür.
  }
  return list;
};
